export class cRelatedProductsTemperature {
  selectInput;

  constructor(id: string) {
    const query = `.c-related-products[data-item-id='${id}'] `;
    this.selectInput   = document.querySelector(query + '.c-related-products-temperature select') as HTMLSelectElement;

    if (this.selectInput === null) return;
    this.selectInput.addEventListener('change', () => {
      window.location.href  = this.selectInput.value;
    });
  }
}